import React, { useEffect, useState } from 'react';
import { fetchDataFromBuilder, getBuilderCacheBusterKey } from 'src/scripts/utils/builder';
import { checkIfCustomer } from 'src/scripts/utils/helpers';
import { openSignInModal } from '../../_shared/ui-components/SignInModal/utils';

const ExcitingPdpBadge = () => {
  const [excitingPdpBadgeConfig, setExcitingPdpBadgeConfig] = useState<ExcitingPdpBadgeConfig | null>(null);

  useEffect(() => {
    const fetchExcitingPdpBadgeConfigFromBuilder = async function () {
      try {
        const data = await fetchDataFromBuilder<ExcitingPdpBadgeConfig>('pdp-exciting-badge', {
          options: { cb: getBuilderCacheBusterKey() },
        }).then((resp) => resp?.data || null);

        if (data && typeof data === 'object' && !Array.isArray(data)) {
          setExcitingPdpBadgeConfig(data);
        } else {
          setExcitingPdpBadgeConfig(null);
          console.warn('[ExcitingPdpBadge] - Invalid data format received from Builder for exciting PDP badge config');
        }
      } catch (error) {
        setExcitingPdpBadgeConfig(null);
        console.error('[ExcitingPdpBadge] - Error fetching exciting PDP badge config from Builder', error);
      }
    };

    fetchExcitingPdpBadgeConfigFromBuilder();
  }, []);

  const isLoggedIn = checkIfCustomer();

  const { signedIn, signedOut } = excitingPdpBadgeConfig || {};
  const badgeText = isLoggedIn ? signedIn?.text : signedOut?.text;

  if (!badgeText || badgeText.trim() === '') return null;

  const excitingPdpBadgeStyles = {
    backgroundColor: isLoggedIn ? signedIn?.badgeColor : signedOut?.badgeColor,
    color: isLoggedIn ? signedIn?.textColor : signedOut?.textColor,
  };

  const url = isLoggedIn ? signedIn?.url : signedOut?.url;

  const excitingPdpBadgeProps = {
    style: excitingPdpBadgeStyles,
    className: 'PDPExcitingThing body',
  };

  if (url && url.trim() !== '') {
    return (
      <a href={url} onClick={handlePdpExcitingBadgeClick} {...excitingPdpBadgeProps}>
        {badgeText}
      </a>
    );
  }

  return <div {...excitingPdpBadgeProps}>{badgeText}</div>;
};

interface ExcitingPdpBadgeConfig {
  signedIn?: {
    badgeColor?: string;
    text?: string;
    textColor?: string;
    url?: string;
  };
  signedOut?: {
    badgeColor?: string;
    text?: string;
    textColor?: string;
    url?: string;
  };
}

const handlePdpExcitingBadgeClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
  const target = event.currentTarget;
  const url = target.getAttribute('href') || '';
  if (url.includes('/account/login')) {
    event.preventDefault();
    const urlParams = new URLSearchParams(url);
    openSignInModal({ tab: urlParams.get('newUser') === 'true' ? 'sign-in' : 'create-account' });
  }
};

export default ExcitingPdpBadge;
